/* C'est du Joly — hauteur fiable des megamenus Packery/Isotope sur desktop. */
(function () {
  'use strict';

  if (window.__cdjDesktopNavigationInitialized) return;
  window.__cdjDesktopNavigationInitialized = true;

  var DESKTOP_QUERY = '(min-width: 1025px)';
  var PANEL_SELECTOR =
    '.t4s-layout-layout_categories #t4s-nav-ul > .t4s-type__mega > .t4s-sub-menu,' +
    '.t4s-layout-layout_categories #t4s-nav-ul > .t4s-type__lv0_mega > .t4s-sub-menu';
  var ITEM_SELECTOR = '.t4s-sub-column-item';
  var resizeObserver = null;
  var mutationObserver = null;
  var observedItems = new WeakSet();
  var scheduledPanels = new WeakMap();
  var resizeTimer = 0;

  function isDesktop() {
    return window.matchMedia ? window.matchMedia(DESKTOP_QUERY).matches : window.innerWidth >= 1025;
  }

  function getMenuRow(panel) {
    if (!panel) return null;
    var container = panel.querySelector('.t4s-container');
    if (!container) return null;

    for (var index = 0; index < container.children.length; index += 1) {
      var child = container.children[index];
      if (child.classList && child.classList.contains('t4s-row') && child.classList.contains('t4s-lazy_menu')) {
        return child;
      }
    }

    return container.querySelector('.t4s-row.t4s-lazy_menu');
  }

  function getDirectMenuItems(row) {
    if (!row) return [];
    return Array.prototype.filter.call(row.children, function (child) {
      return child.matches && child.matches(ITEM_SELECTOR);
    });
  }

  function observeItems(row) {
    if (!resizeObserver || !row) return;

    getDirectMenuItems(row).forEach(function (item) {
      if (observedItems.has(item)) return;
      observedItems.add(item);
      resizeObserver.observe(item);
    });
  }

  function clearMeasurement(panel) {
    var row = getMenuRow(panel);
    if (!row) return;

    row.removeAttribute('data-cdj-menu-measured');
    row.style.removeProperty('--cdj-menu-content-height');
    panel.removeAttribute('data-cdj-menu-measured');
  }

  function measurePanel(panel) {
    if (!panel) return;
    if (!isDesktop()) {
      clearMeasurement(panel);
      return;
    }

    var row = getMenuRow(panel);
    if (!row) return;

    var items = getDirectMenuItems(row);
    if (!items.length) return;

    var rowRect = row.getBoundingClientRect();
    var maximumBottom = 0;

    items.forEach(function (item) {
      var rect = item.getBoundingClientRect();
      if (!rect.height && !item.offsetHeight) return;

      var computed = window.getComputedStyle(item);
      var marginBottom = parseFloat(computed.marginBottom) || 0;
      var relativeBottom = rect.bottom - rowRect.top + marginBottom;
      maximumBottom = Math.max(maximumBottom, relativeBottom);

      /* Certaines polices ou traductions terminent leur mise en page apres le
         premier calcul Packery. Mesurer aussi les descendants visibles evite
         qu'une derniere ligne de texte depasse de son bloc de colonne. */
      item.querySelectorAll('a, li, img, .t4s-heading, .t4s-banner-item, .t4s-banner-content').forEach(function (descendant) {
        var descendantRect = descendant.getBoundingClientRect();
        maximumBottom = Math.max(maximumBottom, descendantRect.bottom - rowRect.top);
      });
    });

    /* Avant notre premiere mesure, scrollHeight couvre aussi le cas ou
       Packery n'a pas encore converti les colonnes en positions absolues. */
    if (!row.hasAttribute('data-cdj-menu-measured')) {
      maximumBottom = Math.max(maximumBottom, row.scrollHeight || 0);
    }

    if (maximumBottom <= 0) return;

    var measuredHeight = Math.ceil(maximumBottom + 2);
    var currentHeight = parseFloat(row.style.getPropertyValue('--cdj-menu-content-height')) || 0;

    if (Math.abs(currentHeight - measuredHeight) > 1) {
      row.style.setProperty('--cdj-menu-content-height', measuredHeight + 'px');
    }

    row.setAttribute('data-cdj-menu-measured', 'true');
    panel.setAttribute('data-cdj-menu-measured', 'true');
    observeItems(row);
  }

  function schedulePanel(panel) {
    if (!panel) return;

    var previous = scheduledPanels.get(panel);
    if (previous) {
      previous.forEach(function (timer) {
        window.clearTimeout(timer);
      });
    }

    var timers = [];
    var run = function () {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          measurePanel(panel);
        });
      });
    };

    run();
    [40, 120, 280, 650].forEach(function (delay) {
      timers.push(window.setTimeout(run, delay));
    });
    scheduledPanels.set(panel, timers);
  }

  function getPanels(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var panels = [];

    if (scope.matches && scope.matches(PANEL_SELECTOR)) panels.push(scope);
    scope.querySelectorAll(PANEL_SELECTOR).forEach(function (panel) {
      panels.push(panel);
    });

    return panels;
  }

  function refresh(root) {
    getPanels(root).forEach(function (panel) {
      observeItems(getMenuRow(panel));
      schedulePanel(panel);
    });
  }

  function panelFromTarget(target) {
    if (!target || !target.closest) return null;
    var menuItem = target.closest('.t4s-type__mega, .t4s-type__lv0_mega');
    return menuItem ? menuItem.querySelector(':scope > .t4s-sub-menu') : null;
  }

  function initializeObservers() {
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(function (entries) {
        var panels = new Set();
        entries.forEach(function (entry) {
          var panel = entry.target.closest ? entry.target.closest('.t4s-sub-menu') : null;
          if (panel && panel.matches(PANEL_SELECTOR)) panels.add(panel);
        });
        panels.forEach(schedulePanel);
      });
    }

    mutationObserver = new MutationObserver(function (mutations) {
      var panels = new Set();

      mutations.forEach(function (mutation) {
        var targetPanel = mutation.target.closest ? mutation.target.closest('.t4s-sub-menu') : null;
        if (targetPanel && targetPanel.matches(PANEL_SELECTOR)) panels.add(targetPanel);

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          getPanels(node).forEach(function (panel) {
            panels.add(panel);
          });
          var containingPanel = node.closest ? node.closest('.t4s-sub-menu') : null;
          if (containingPanel && containingPanel.matches(PANEL_SELECTOR)) panels.add(containingPanel);
        });
      });

      panels.forEach(function (panel) {
        observeItems(getMenuRow(panel));
        schedulePanel(panel);
      });
    });

    if (document.body) {
      mutationObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  function start() {
    initializeObservers();
    refresh(document);

    document.addEventListener('mouseover', function (event) {
      var panel = panelFromTarget(event.target);
      if (panel) schedulePanel(panel);
    }, true);

    document.addEventListener('focusin', function (event) {
      var panel = panelFromTarget(event.target);
      if (panel) schedulePanel(panel);
    });

    document.addEventListener('load', function (event) {
      if (!(event.target instanceof HTMLImageElement)) return;
      var panel = event.target.closest('.t4s-sub-menu');
      if (panel && panel.matches(PANEL_SELECTOR)) schedulePanel(panel);
    }, true);

    document.addEventListener('lazyloaded', function (event) {
      var panel = event.target && event.target.closest ? event.target.closest('.t4s-sub-menu') : null;
      if (panel && panel.matches(PANEL_SELECTOR)) schedulePanel(panel);
    });

    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        refresh(document);
      }, 120);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        refresh(document);
      });
    }

    window.setTimeout(function () { refresh(document); }, 1000);
    window.setTimeout(function () { refresh(document); }, 2500);
  }

  window.CDJDesktopNavigation = {
    refresh: function () { refresh(document); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
